<template>
  <div class="dialog_background">
    <div class="dialog_container">
      <img
        v-if="dialog.icon !== null && dialog.icon !== undefined"
        class="alert_logo"
        :src="`/assets/images/common/dialog/alert_${dialog.icon}.png`"
        alt="alert_logo"
        width="40"
        height="40"
      />

      <div
        class="title_group"
        :style="{ marginBottom: titleMargin, fontSize: common.dialog.title_size + 'px' }"
      >
        <p class="title" v-if="dialog.title !== null && dialog.title !== undefined">
          <span v-for="(line, index) in dialog.title.split('\n')" :key="index">
          {{ line }} <br>
        </span>
        </p>
        <p class="info" v-if="dialog.info !== null && dialog.info !== undefined">
           <span v-for="(line, index) in dialog.info.split('\n')" :key="index">
          {{ line }} <br>
           </span>
        </p>
      </div>

      <div class="subTitle" v-if="dialog.subTitle !== null && dialog.subTitle !== undefined">
        <div class="account_info_box">
          <span v-for="(line, index) in dialog.subTitle.split('\n')" :key="index" :class="getAccountLineClass(index, dialog.subTitle.split('\n').length)">
            {{ line }}
          </span>
        </div>
      </div>

      <div class="buttonGroup">
        <button
          :class="!cancelButton ? 'closeButton' : 'cancelButton'"
          :style="{ width: buttonWidth }"
          @click="common.closeDialog()"
          @keypress.enter="common.closeDialog()"
        >
          {{ cancelButton ? '취소' : '닫기' }}
        </button>
        <button
          v-if="dialog.button !== null && dialog.button !== undefined"
          class="addButton"
          :class="dialog.button.color"
          @click="confirm"
        >
          {{ dialog.button.content }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    confirm() {
      this.common.dialog.button.onClick();
      this.common.closeDialog();
    },
    getAccountLineClass(index, totalLines) {
      // 계좌번호 안내 형식인지 확인 (KB국민은행으로 시작하는 경우)
      const subTitle = this.common.dialog.subTitle;
      if (!subTitle) return '';
      const lines = subTitle.split('\n') || [];
      if (lines.length > 0 && lines[0].includes('KB국민')) {
        if (index === 0) return 'bank_name'; // 은행명
        if (index === 1) return 'account_number'; // 계좌번호
        if (index === 2) return 'account_holder'; // 예금주
        if (index === 3) return 'empty_line'; // 빈 줄
        if (index === 4) return 'instruction'; // 안내 문구
      }
      return '';
    }
  },
  computed: {
    dialog() {
      return this.common.dialog;
    },
    buttonWidth() {
      return this.common.dialog.button === null ? '380px' : '170px';
    },
    titleMargin() {
      return this.common.dialog.subTitle === null || this.common.dialog.subTitle === undefined
        ? '50px'
        : '17px';
    },
    cancelButton() {
      return this.common.dialog.button !== null && this.common.dialog.button !== undefined;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/style/common/dialog.scss';
</style>
